import Swal from 'sweetalert2'

export const alertaPersonalizadaSwal = (title, text="", icon='error', allowOutsideClick = false) => Swal.fire({ title, text, icon, allowOutsideClick})